import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';

const BLOCK_INDENT = 20;
const BLOCK_BOTTOM_SPACING = 5.5;

interface EmptyStateWrapperProps {
  children: ReactNode;
}

const EmptyStateWrapper = ({ children }: EmptyStateWrapperProps) => (
  <Stack
    sx={{
      minHeight: '100%',
      justifyContent: 'center',
      alignItems: { xs: 'center', md: 'flex-start' },
      px: { xs: 3, md: 0 },
    }}
  >
    <Box sx={{ ml: { xs: 0, md: BLOCK_INDENT }, pb: BLOCK_BOTTOM_SPACING }}>{children}</Box>
  </Stack>
);

export default EmptyStateWrapper;
